import React from 'react';
import { Link } from 'react-router-dom';
import './sidebar.css'

export default function Sidebar() {
  return (
    <div className="sidebar">
      <div className="sidebarWrapper">
        <div className="menu">
          <h3 className="title">Dashboard</h3>
          <ul className="list">
            <Link to='/' className='link'>
              <li className="listItem">Home</li>
            </Link>
          </ul>
        </div>

        <div className="menu">
          <h3 className="title">User</h3>
          <ul className="list">
            <Link to='/overUsers' className='link'>
              <li className="listItem">Overview</li>
            </Link>
            <Link to='/addUsers' className='link'>
              <li className="listItem">Add</li>
            </Link>
          </ul>
        </div>

        <div className="menu">
          <h3 className="title">Blood Banks</h3>
          <ul className="list">
            <Link to='/overBB' className='link'>
              <li className="listItem">Overview</li>
            </Link>
            <Link to='/addBB' className='link'>
              <li className="listItem">Add</li>
            </Link>
          </ul>
        </div>
        
        <div className="menu">
          <h3 className="title">Blood Requests</h3>
          <ul className="list">
            <Link to='/overBR' className='link'>
              <li className="listItem">Overview</li>
            </Link>
            <Link to='/addBR' className='link'>
              <li className="listItem">Add</li>
            </Link>
          </ul>
        </div>

        <div className="menu">
          <h3 className="title">Donation Events</h3>
          <ul className="list">
            <Link to='/overDP' className='link'>
              <li className="listItem">Overview</li>
            </Link>
            <Link to='/addDP' className='link'>
              <li className="listItem">Add</li>
            </Link>
          </ul>
        </div>
      </div>      
    </div>
  );
}
